module.exports = __webpack_public_path__ + "static/sport/game-1.25b3fc7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sport7/game-1.png
// module id = P26U
// module chunks = 0